"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DwebgClient = exports.ConnectionStatusStream = exports.ConnectionStatus = exports.TableResult = exports.Uuid = void 0;
const luxon_1 = require("luxon");
const websocket_1 = require("websocket");
const duration_1 = require("./google/protobuf/duration");
const timestamp_1 = require("./google/protobuf/timestamp");
const message_1 = require("./message");
const struct_1 = require("./google/protobuf/struct");
const UUID = __importStar(require("uuid"));
var NullValue = struct_1.google.protobuf.NullValue;
var MsgTimestamp = timestamp_1.google.protobuf.Timestamp;
var MsgDuration = duration_1.google.protobuf.Duration;
var MsgValue = message_1.DwebgMessage.Value;
var MsgList = message_1.DwebgMessage.List;
var MsgMap = message_1.DwebgMessage.Map_;
// log
function log(...msg) {
    if (DwebgClient.LOGGING_ENABLED) {
        console.log(...msg);
    }
}
class _Id {
    static next() {
        _Id._id += 1;
        return _Id._id;
    }
    static makeTag(tag) {
        return `${_Id.next()}-${tag !== null && tag !== void 0 ? tag : ''}`;
    }
}
_Id._id = 0;
class _FromProto {
    static convertList(value) {
        return value.list.values.map((x) => _FromProto.get(x));
    }
    static convertMap(value) {
        const map = value.map.values;
        const result = {};
        if (map) {
            map.forEach((v, k) => {
                result[k] = _FromProto.get(v);
            });
        }
        return result;
    }
    static get(value) {
        var _a;
        if (value === null || value === undefined) {
            return null;
        }
        const valueType = (_a = value.value_type) !== null && _a !== void 0 ? _a : 'null';
        const mapping = _FromProto.mapping;
        return valueType in mapping ? mapping[valueType](value) : null;
    }
}
_FromProto.mapping = {
    'none': (_) => null,
    'null': (_) => null,
    'i32': (x) => x.i32,
    'i64': (x) => x.i64,
    'f64': (x) => x.f64,
    'string': (x) => x.string,
    'bool': (x) => x.bool,
    'bytes': (x) => x.bytes,
    'uuid': (x) => new Uuid(x.uuid),
    'map': (x) => _FromProto.convertMap(x),
    'list': (x) => _FromProto.convertList(x),
    'timestamp': (x) => new Date(x.timestamp.seconds * 1000 + x.timestamp.nanos / 1000000),
    // as milliseconds...
    'duration': (x) => x.duration.seconds * 1000 + x.duration.nanos / 1000000,
    'millis_since_midnight': (x) => new Date(x.millis_since_midnight),
    'days_since_epoch': (x) => new Date(x.days_since_epoch * 86400000),
};
// Declare a UUID wrapper:
class Uuid {
    constructor(uuid) {
        this._bytes = uuid;
    }
    get bytes() {
        return this._bytes;
    }
    static fromString(uuid) {
        return new Uuid(UUID.parse(uuid));
    }
    toString() {
        return UUID.stringify(this._bytes);
    }
}
exports.Uuid = Uuid;
function toProto(value) {
    if (value === null || value === undefined) {
        return new message_1.DwebgMessage.Value({ null: NullValue.NULL_VALUE });
    }
    switch (typeof value) {
        // bigint case:
        case 'bigint':
            return new MsgValue({ i64: Number(value) });
        case 'boolean':
            return new MsgValue({ bool: value });
        case 'number':
            if (Number.isInteger(value)) {
                return new MsgValue({ i64: value });
            }
            return new MsgValue({ f64: value });
        case 'string':
            return new MsgValue({ string: value });
        case 'object':
            if (value instanceof MsgValue) {
                return value;
            }
            else if (value instanceof MsgMap) {
                return new MsgValue({ map: value });
            }
            else if (value instanceof MsgList) {
                return new MsgValue({ list: value });
            }
            else if (value instanceof MsgTimestamp) {
                return new MsgValue({ timestamp: value });
            }
            else if (value instanceof MsgDuration) {
                return new MsgValue({ duration: value });
            }
            else if (value instanceof Uuid) {
                return new MsgValue({ uuid: value.bytes });
            }
            else if (value instanceof Uint8Array) {
                return new MsgValue({ bytes: value });
            }
            else if (Array.isArray(value)) {
                const values = value.map(toProto);
                return new MsgValue({ list: new MsgList({ values: values }) });
            }
            else if (value instanceof Uint8Array) {
                return new MsgValue({ bytes: value });
            }
            else if (value instanceof Date) {
                // Time-of-day case:
                if (value.getUTCFullYear() === 1970 && value.getUTCMonth() === 0 && value.getUTCDate() === 1) {
                    return new MsgValue({
                        millis_since_midnight: value.getUTCHours() * 3600000 + value.getUTCMinutes() * 60000 + value.getUTCSeconds() * 1000 + value.getUTCMilliseconds(),
                    });
                }
                // Date case:
                else if (value.getUTCHours() === 0 && value.getUTCMinutes() === 0 && value.getUTCSeconds() === 0 && value.getUTCMilliseconds() === 0) {
                    return new MsgValue({
                        days_since_epoch: Math.floor(value.getTime() / 86400000),
                    });
                }
                // Timestamp case:
                else {
                    const seconds = Math.floor(value.getTime() / 1000);
                    const nanos = value.getMilliseconds() * 1000000;
                    return new MsgValue({
                        timestamp: new MsgTimestamp({
                            seconds: seconds,
                            nanos: nanos,
                        }),
                    });
                }
            }
            else if (value instanceof luxon_1.Duration) {
                const millis = value.toMillis();
                return new MsgValue({
                    duration: new MsgDuration({
                        seconds: Math.floor(millis / 1000),
                        nanos: (millis % 1000) * 1000000,
                    }),
                });
            }
            // For Uuid, and Bytes, accept {"uuid": "..."} and {"bytes": "..."}
            else if (value.i32) {
                return new MsgValue({ i32: value.i32 });
            }
            else if (value.i64) {
                return new MsgValue({ i64: value.i64 });
            }
            else if (value.f64) {
                return new MsgValue({ f64: value.f64 });
            }
            else if (value.string) {
                return new MsgValue({ string: value.string });
            }
            else if (value.bool) {
                return new MsgValue({ bool: value.bool });
            }
            else if (value.uuid) {
                return new MsgValue({ uuid: value.uuid });
            }
            else if (value.bytes) {
                return new MsgValue({ bytes: value.bytes });
            }
            else if (value.millis_since_midnight) {
                return new MsgValue({ millis_since_midnight: value.millis_since_midnight });
            }
            else if (value.days_since_epoch) {
                return new MsgValue({ days_since_epoch: value.days_since_epoch });
            }
            else if (value instanceof luxon_1.DateTime) {
                return new MsgValue({
                    timestamp: new MsgTimestamp({
                        seconds: value.toSeconds(),
                        nanos: value.toMillis() % 1000,
                    }),
                });
            }
            else if (value instanceof luxon_1.Interval) {
                const duration = value.toDuration();
                const millis = duration.toMillis();
                return new MsgValue({
                    duration: new MsgDuration({
                        seconds: Math.floor(millis / 1000),
                        nanos: (millis % 1000) * 1000000,
                    }),
                });
            }
            // If it has iterable pairs and keys and values methods, then treat as a map:
            else {
                return new MsgValue({
                    map: new MsgMap({
                        values: new Map(Object.entries(value).map(([k, v]) => [k, toProto(v)])),
                    }),
                });
            }
    }
    throw new Error(`Unsupported type: ${typeof value}`);
}
class TableResult {
    constructor(columnNames, rows) {
        this.columnNames = columnNames;
        this.rows = rows;
    }
    getRows(columnNames) {
        const columnIndexes = [];
        for (const name of columnNames) {
            const index = this.columnNames.indexOf(name);
            if (index < 0) {
                throw new Error(`Column ${name} not found`);
            }
            columnIndexes.push(index);
        }
        return this.rows.map((row) => columnIndexes.map((i) => row[i]));
    }
    labelledRows() {
        return this.rows.map((row) => {
            const obj = {};
            for (let i = 0; i < this.columnNames.length; i++) {
                obj[this.columnNames[i]] = row[i];
            }
            return obj;
        });
    }
    toSingleScalar() {
        if (this.rows.length < 1 || this.rows[0].length < 1) {
            return null;
        }
        return this.rows[0][0];
    }
    toSingleRow() {
        if (this.rows.length < 1) {
            return {};
        }
        const obj = {};
        for (let i = 0; i < this.columnNames.length; i++) {
            obj[this.columnNames[i]] = this.rows[0][i];
        }
        return obj;
    }
}
exports.TableResult = TableResult;
var ConnectionStatus;
(function (ConnectionStatus) {
    ConnectionStatus[ConnectionStatus["Connecting"] = 1] = "Connecting";
    ConnectionStatus[ConnectionStatus["ConnectedPreAuth"] = 2] = "ConnectedPreAuth";
    ConnectionStatus[ConnectionStatus["ConnectedPendingAuth"] = 3] = "ConnectedPendingAuth";
    ConnectionStatus[ConnectionStatus["ConnectedWithAuth"] = 4] = "ConnectedWithAuth";
    ConnectionStatus[ConnectionStatus["Closed"] = 5] = "Closed";
    ConnectionStatus[ConnectionStatus["Failed"] = 6] = "Failed";
})(ConnectionStatus = exports.ConnectionStatus || (exports.ConnectionStatus = {}));
class ConnectionStatusStream {
    constructor() {
        this._value = ConnectionStatus.Connecting;
        this._error = null;
        this._errorCause = null;
        this._eventTarget = new EventTarget();
    }
    get value() {
        return this._value;
    }
    get error() {
        return this._error;
    }
    get errorCause() {
        return this._errorCause;
    }
    get errorBecauseExpired() {
        return this._errorCause === message_1.DwebgMessage.SessionCause.SESSION_CAUSE_EXPIRED_SESSION
            || this._errorCause === message_1.DwebgMessage.SessionCause.SESSION_CAUSE_EXPIRED_IDENTITY;
    }
    set(value, force = false) {
        if (value === this._value) {
            return;
        }
        if (!force) {
            if (this._value === ConnectionStatus.Failed) {
                throw new Error(`Connection failed: ${this._error} (${this._errorCause})`);
            }
            if (this._value === ConnectionStatus.Closed) {
                throw new Error('Connection is closed');
            }
            if (value === ConnectionStatus.Failed) {
                throw new Error('Connection failed: Unknown cause');
            }
        }
        log(`ConnectionStatus: ${ConnectionStatus[this._value]} -> ${ConnectionStatus[value]}`);
        this._error = null;
        this._errorCause = null;
        this._value = value;
        this._eventTarget.dispatchEvent(new Event('change'));
    }
    setError(error, cause) {
        log(`Error: ${error} (${cause}). ConnectionStatus: ${ConnectionStatus[this._value]} -> Failed`);
        this._value = ConnectionStatus.Failed;
        this._error = error !== null && error !== void 0 ? error : 'unknown error';
        this._errorCause = cause;
        this._eventTarget.dispatchEvent(new Event('change'));
    }
    addEventListener(type, listener) {
        this._eventTarget.addEventListener(type, listener);
    }
    removeEventListener(type, listener) {
        this._eventTarget.removeEventListener(type, listener);
    }
}
exports.ConnectionStatusStream = ConnectionStatusStream;
class PendingQuery {
    constructor(batchId, query) {
        this.batchId = batchId;
        this.query = query;
        this.promise = new Promise((resolve, reject) => {
            this.reject = reject;
            this.resolve = resolve;
        });
    }
    isDone() {
        let done = false;
        this.promise.then((_) => {
            done = true;
        }).catch((_) => {
            done = true;
        });
        return done;
    }
}
class DwebgClient {
    constructor(options) {
        var _a, _b, _c;
        this._connectionError = null;
        this._authError = null;
        this._connectionStatus = new ConnectionStatusStream();
        this._websocket = null;
        this._pendingQueries = new Map();
        this._connected = false;
        this._reconnecting = false;
        this._needsJwtRefresh = true;
        this._refreshTimer = null;
        this._refreshIndex = 0;
        this._server = options.server;
        this._database = options.database;
        this._schema = options.schema;
        this._url = options.url;
        this._username = options.username;
        this._password = options.password;
        this._getJwt = options.getJwt;
        this._timeoutSeconds = options.timeoutSeconds;
        this._autoReconnect = (_a = options.autoReconnect) !== null && _a !== void 0 ? _a : true;
        this._sessionToken = (_b = options.sessionToken) !== null && _b !== void 0 ? _b : undefined;
        this._refreshBeforeExpirySeconds = (_c = options.refreshBeforeExpirySeconds) !== null && _c !== void 0 ? _c : 60;
    }
    // Session token getter:
    get sessionToken() {
        return this._sessionToken;
    }
    get connectionStatus() {
        return this._connectionStatus;
    }
    waitUntilAuthenticated() {
        return new Promise((resolve, reject) => {
            const onChange = () => {
                let fin = true;
                if (this._connectionStatus.value === ConnectionStatus.ConnectedWithAuth) {
                    resolve();
                }
                else if (this._connectionStatus.value === ConnectionStatus.Failed) {
                    reject(this._connectionStatus.error);
                }
                else if (this._connectionStatus.value === ConnectionStatus.Closed) {
                    reject('closed');
                }
                else {
                    fin = false;
                }
                if (fin) {
                    this._connectionStatus.removeEventListener('change', onChange);
                }
            };
            this._connectionStatus.addEventListener('change', onChange);
            onChange();
        });
    }
    _waitUntilConnected() {
        // check if already connected:
        return new Promise((resolve, reject) => {
            const onChange = () => {
                let fin = true;
                if (this._connectionStatus.value === ConnectionStatus.Failed) {
                    reject(this._connectionStatus.error);
                }
                else if (this._connectionStatus.value === ConnectionStatus.Closed) {
                    reject('closed');
                }
                else if (this._connectionStatus.value !== ConnectionStatus.Connecting) {
                    resolve();
                }
                else {
                    fin = false;
                }
                if (fin) {
                    this._connectionStatus.removeEventListener('change', onChange);
                }
            };
            this._connectionStatus.addEventListener('change', onChange);
            onChange();
        });
    }
    connectAndWaitUntilAuthenticated() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.connect();
            yield this.waitUntilAuthenticated();
        });
    }
    connect() {
        return __awaiter(this, void 0, void 0, function* () {
            log('connecting');
            try {
                yield this._connectWithOptionalTimeout();
                this._connected = true;
                // await this.waitUntilAuthenticated();
            }
            catch (error) {
                this._ensureConnectionNotFailed();
                // Throw specific errors if required
                // @ts-ignore
                if (error.message === 'Timeout') {
                    if (this._connectionError) {
                        throw this._connectionError;
                    }
                    else if (this._authError) {
                        throw this._authError;
                    }
                    else {
                        throw new Error('Connection or Authentication timed out');
                    }
                }
                // Otherwise retry
                log(`FAILED TO CONNECT: ${error}`);
                this._connected = false;
                if (this._autoReconnect) {
                    yield this._reconnect();
                }
                else {
                    throw error;
                }
            }
        });
    }
    _connectWithOptionalTimeout() {
        return __awaiter(this, void 0, void 0, function* () {
            const timeout = this._timeoutSeconds;
            if (timeout !== undefined) {
                yield Promise.race([
                    this._connect(),
                    new Promise((_, reject) => {
                        setTimeout(() => {
                            this.setError("Timed out", message_1.DwebgMessage.SessionCause.SESSION_CAUSE_UNKNOWN);
                            reject(new Error('Timeout'));
                        }, timeout * 1000);
                    }),
                ]);
            }
            else {
                yield this._connect();
            }
        });
    }
    exec(query, opts = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.query(query, opts);
        });
    }
    query(query, opts = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            log('query:', query);
            this._ensureConnectionNotFailed();
            yield this.waitUntilAuthenticated();
            this._ensureConnectionNotFailed();
            // await this.waitUntilAuthenticated();
            let { params, tag } = opts;
            if (!params) {
                params = [];
            }
            tag = _Id.makeTag(tag);
            const request = new message_1.DwebgMessage.Request({
                batch_query: new message_1.DwebgMessage.BatchQuery({
                    batch_id: tag,
                    queries: [
                        new message_1.DwebgMessage.Query({
                            statement: query,
                            database: this._database,
                            schema: this._schema,
                            server: this._server,
                            parameters: params.map((p) => toProto(p)),
                            statement_id: '0',
                        }),
                    ],
                }),
            });
            const res = yield this._sendRequest(request);
            if (res && res.length > 0) {
                return yield res[0].promise;
            }
            else {
                throw new Error('No results');
            }
        });
    }
    batchQuery(queries, opts = {}) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            this._ensureConnectionNotFailed();
            yield this.waitUntilAuthenticated();
            this._ensureConnectionNotFailed();
            const batchTag = _Id.makeTag(opts.batchTag);
            const queriesMapped = queries.map((q) => {
                if (typeof q === 'string') {
                    return { query: q };
                }
                return q;
            });
            const request = new message_1.DwebgMessage.Request({
                batch_query: new message_1.DwebgMessage.BatchQuery({
                    batch_id: batchTag,
                    single_transaction: (_a = opts.inTransaction) !== null && _a !== void 0 ? _a : false,
                    queries: queriesMapped.map(({ query, params, tag, then }, index) => {
                        return new message_1.DwebgMessage.Query({
                            statement: query,
                            database: this._database,
                            schema: this._schema,
                            server: this._server,
                            parameters: params === null || params === void 0 ? void 0 : params.map((p) => toProto(p)),
                            statement_id: `${index}${tag != undefined ? `-${tag}` : ''}`,
                        });
                    }),
                }),
            });
            const res = yield this._sendRequest(request);
            if (res && res.length > 0) {
                return Promise.all(res.map((r, i) => {
                    const query = queriesMapped[i];
                    if (!query) {
                        return r.promise;
                    }
                    const then = query.then;
                    let res = r.promise;
                    if (then) {
                        return res.then((x) => __awaiter(this, void 0, void 0, function* () {
                            yield then({ result: x });
                            return x;
                        })).catch((x) => __awaiter(this, void 0, void 0, function* () {
                            yield then({ error: x });
                            return x;
                        }));
                    }
                    else {
                        return res;
                    }
                }));
            }
            else {
                throw new Error('No results');
            }
        });
    }
    queryOne(query, opts = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.query(query, opts);
            return res.toSingleRow();
        });
    }
    queryScalar(query, opts = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.query(query, opts);
            return res.toSingleScalar();
        });
    }
    close() {
        return __awaiter(this, void 0, void 0, function* () {
            // If failed, don't try to close
            log('Closing connection');
            if (this.connectionStatus.value !== ConnectionStatus.Failed) {
                this.connectionStatus.set(ConnectionStatus.Closed);
            }
            this._connected = false;
            if (this._websocket) {
                this._websocket.close();
            }
        });
    }
    _forceCloseWebsocket() {
        var _a;
        (_a = this._websocket) === null || _a === void 0 ? void 0 : _a.close();
    }
    _connect() {
        return __awaiter(this, void 0, void 0, function* () {
            log(`connecting ws: ${this._url}`);
            const websocket = new websocket_1.w3cwebsocket(this._url);
            websocket.binaryType = 'arraybuffer';
            websocket.onopen = () => __awaiter(this, void 0, void 0, function* () {
                log('ws: connect');
                this._connectionStatus.set(ConnectionStatus.ConnectedPreAuth, true);
                try {
                    yield this._authenticate();
                }
                catch (error) {
                    this._connected = false;
                    // this._connectionStatus.setError(error, proto.SessionCause.SESSION_CAUSE_UNKNOWN);
                    yield this._reconnect();
                    console.error(error);
                    throw error;
                }
            });
            websocket.onerror = (error) => __awaiter(this, void 0, void 0, function* () {
                this._connectionError = error;
                log(`ws: connect_error ${JSON.stringify(error)}`);
                if (this._autoReconnect) {
                    yield this._reconnect();
                }
                else {
                    this.setError(error, message_1.DwebgMessage.SessionCause.SESSION_CAUSE_UNKNOWN);
                }
            });
            websocket.onclose = () => __awaiter(this, void 0, void 0, function* () {
                log('ws: disconnect');
                yield this._handleConnectionClosed();
            });
            websocket.onmessage = (message) => __awaiter(this, void 0, void 0, function* () {
                // ignore if string:
                if (typeof message.data === 'string') {
                    return;
                }
                try {
                    // @ts-ignore
                    const resp = message_1.DwebgMessage.Response.deserializeBinary(message.data);
                    yield this._handleResponse(resp);
                }
                catch (error) {
                    console.error(error);
                }
            });
            this._websocket = websocket;
        });
    }
    /*    def _ensure_connection_not_failed(self) -> None:
        if self.connection_status.value == ConnectionStatus.Failed:
            raise ConnectionError(
                f"Connection failed: {self.connection_status.error} ({self.connection_status.error_cause})")
        if self.connection_status.value == ConnectionStatus.Closed:
            raise ConnectionError("Connection closed.")
     */
    _ensureConnectionNotFailed() {
        if (this._connectionStatus.value === ConnectionStatus.Failed) {
            throw new Error(`Connection failed: ${this._connectionStatus.error} (${this._connectionStatus.errorCause})`);
        }
        if (this._connectionStatus.value === ConnectionStatus.Closed) {
            throw new Error('Connection closed.');
        }
    }
    setError(error, cause) {
        this.connectionStatus.setError(error, cause);
        this._takePendingQueries().forEach((f) => f.reject(error));
    }
    _authenticate() {
        return __awaiter(this, void 0, void 0, function* () {
            this._ensureConnectionNotFailed();
            yield this._waitUntilConnected();
            log('authenticating');
            if (this._connectionStatus.value !== ConnectionStatus.ConnectedWithAuth) {
                this._connectionStatus.set(ConnectionStatus.ConnectedPreAuth);
            }
            const tag = _Id.makeTag('auth');
            // If already have a session token, just use that
            if (this._sessionToken) {
                log(`Using existing session token`);
                const request = new message_1.DwebgMessage.Request({
                    attach_session_token: new message_1.DwebgMessage.AttachSessionToken({
                        request_id: tag,
                        token: this._sessionToken,
                    }),
                });
                yield this._sendRequest(request);
                if (this._connectionStatus.value !== ConnectionStatus.ConnectedWithAuth) {
                    this._connectionStatus.set(ConnectionStatus.ConnectedPendingAuth);
                }
                return;
            }
            const credentials = new message_1.DwebgMessage.GetSessionToken({ request_id: tag });
            if (this._getJwt) {
                log(`Getting session token from jwt`);
                let jwt = yield this._getJwt(this._needsJwtRefresh).catch((e) => {
                    log(`No identity token provided`);
                    this.setError(new Error('Could not get identity token'), message_1.DwebgMessage.SessionCause.SESSION_CAUSE_INVALID_IDENTITY);
                    throw new Error(`Could not get identity token: ${e}`);
                });
                if (jwt) {
                    this._needsJwtRefresh = false;
                }
                if (!jwt) {
                    log(`No identity token provided`);
                    this.setError(new Error('No identity token'), message_1.DwebgMessage.SessionCause.SESSION_CAUSE_INVALID_IDENTITY);
                    throw new Error('No identity token');
                }
                log(`Set identity token`);
                credentials.identity = jwt;
            }
            else if (this._username && this._password) {
                log(`Getting session token from username/password`);
                credentials.credentials = new message_1.DwebgMessage.LoginCredentials({
                    username: this._username,
                    password: this._password,
                });
            }
            else {
                log(`Getting session token, but no credentials provided`);
                this.setError(new Error('No credentials provided'), message_1.DwebgMessage.SessionCause.SESSION_CAUSE_MISSING_CREDENTIALS);
                throw new Error('No credentials provided');
            }
            const request = new message_1.DwebgMessage.Request({ get_session_token: credentials });
            yield this._sendRequest(request);
            if (this._connectionStatus.value !== ConnectionStatus.ConnectedWithAuth) {
                this._connectionStatus.set(ConnectionStatus.ConnectedPendingAuth);
            }
        });
    }
    _resendQuery(batchId, query) {
        return __awaiter(this, void 0, void 0, function* () {
            let request = new message_1.DwebgMessage.Request({
                batch_query: new message_1.DwebgMessage.BatchQuery({
                    batch_id: batchId,
                    queries: [query],
                }),
            });
            yield this._websocket.send(request.serializeBinary());
        });
    }
    _sendRequest(request) {
        return __awaiter(this, void 0, void 0, function* () {
            this._ensureConnectionNotFailed();
            yield this._waitUntilConnected();
            this._ensureConnectionNotFailed();
            log('sending request');
            // If batch query, then add to pending queries:
            let futs = [];
            if (request.has_batch_query) {
                const req = request.batch_query;
                const batchId = req.batch_id;
                for (let x of req.queries) {
                    let fut = new PendingQuery(batchId, x);
                    if (!this._pendingQueries.has(req.batch_id)) {
                        this._pendingQueries.set(req.batch_id, new Map());
                    }
                    this._pendingQueries.get(req.batch_id).set(x.statement_id, fut);
                    futs.push(fut);
                }
                try {
                    log('sending request on websocket');
                    yield this._waitUntilConnected();
                    this._websocket.send(request.serializeBinary());
                }
                catch (error) {
                    log(`sending request failed: ${error}`);
                    for (let fut of futs) {
                        fut.reject(error);
                    }
                    this._takePendingQueries(batchId).forEach((f) => f.reject(new Error('Failed to send request')));
                    this._connected = false;
                    this._connectionStatus.set(ConnectionStatus.Connecting);
                    yield this._reconnect();
                    return undefined;
                }
                return futs;
            }
            else {
                try {
                    log('sending request on websocket');
                    yield this._waitUntilConnected();
                    this._websocket.send(request.serializeBinary());
                }
                catch (error) {
                    log(`sending request failed: ${error}`);
                    this._connected = false;
                    yield this._reconnect();
                    return undefined;
                }
            }
        });
    }
    _handleResponse(response) {
        var _a, _b, _c;
        return __awaiter(this, void 0, void 0, function* () {
            log(`handling response: ${JSON.stringify(response.toObject())}`);
            if (response.has_query_results) {
                const resp = response.query_results;
                const batchId = resp.batch_id;
                const statementId = resp.statement_id;
                log(`handling response: query_results: ${batchId}, ${statementId}`);
                const future = this._takePendingQueries(batchId, statementId).at(0);
                if (future) {
                    const res = new TableResult(resp.column_names, (_c = (_b = (_a = resp.records) === null || _a === void 0 ? void 0 : _a.rows) === null || _b === void 0 ? void 0 : _b.map((r) => r.values.map((v) => _FromProto.get(v)))) !== null && _c !== void 0 ? _c : []);
                    log(`handling response: query_results: ${batchId}, ${statementId}: resolving`);
                    future.resolve(res);
                }
            }
            if (response.has_batch_query_error) {
                const resp = response.batch_query_error;
                const batchId = resp.batch_id;
                const statementId = resp.statement_id;
                this._takePendingQueries(batchId, statementId).forEach((f) => {
                    log(`handling response: batch_query_error: ${batchId}, ${statementId}: rejecting`);
                    f.reject({ message: resp.error, cause: resp.cause });
                });
            }
            if (response.has_session_error) {
                const resp = response.session_error;
                this._connected = false;
                log(`handling response: session_error: ${resp.error}, ${resp.cause}`);
                this._authError = new Error(resp.error);
                if ((resp.cause === message_1.DwebgMessage.SessionCause.SESSION_CAUSE_EXPIRED_SESSION
                    && (this._getJwt || this._username || this._password))
                    || resp.cause === message_1.DwebgMessage.SessionCause.SESSION_CAUSE_EXPIRED_IDENTITY) {
                    this._needsJwtRefresh = true;
                    this._connectionStatus.set(ConnectionStatus.ConnectedPreAuth);
                    yield this._reconnect();
                }
                else {
                    this.setError(resp.error, resp.cause);
                }
            }
            if (response.has_session_token_status_change) {
                this._connected = true;
                this._sessionToken = response.session_token_status_change.token;
                log('handling response: session_token_status_change: connected');
                this._connectionStatus.set(ConnectionStatus.ConnectedWithAuth);
                this._updateRefreshTime(response.session_token_status_change.expires_in_ms);
            }
            if (response.has_attach_session_token_response) {
                this._connected = true;
                log('handling response: attach_session_token_response');
                this._connectionStatus.set(ConnectionStatus.ConnectedWithAuth);
                this._updateRefreshTime(response.attach_session_token_response.expires_in_ms);
            }
        });
    }
    // but in typescript:
    _maybeReauthenticate(index) {
        return __awaiter(this, void 0, void 0, function* () {
            if (index === this._refreshIndex
                && this._connectionStatus.value !== ConnectionStatus.Closed
                && this._connectionStatus.value !== ConnectionStatus.Failed) {
                log(`reauthenticating (${index})`);
                this._sessionToken = undefined;
                yield this._authenticate();
            }
        });
    }
    _updateRefreshTime(expiresInMs) {
        if (this._username === undefined && this._password === undefined && this._getJwt === undefined) {
            return;
        }
        const index = this._refreshIndex + 1;
        this._refreshIndex = index;
        if (expiresInMs === undefined || expiresInMs === 0) {
            return;
        }
        const refreshInSecs = Math.max(1, expiresInMs / 1000.0 - this._refreshBeforeExpirySeconds);
        log(`Refreshing in ${refreshInSecs} seconds. Expires in ${expiresInMs / 1000.0} seconds.`);
        setTimeout(() => this._maybeReauthenticate(index), refreshInSecs * 1000);
    }
    _reconnect() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this._connected) {
                return;
            }
            if (this._reconnecting) {
                return;
            }
            log('reconnecting');
            this._reconnecting = true;
            try {
                this._connectionStatus.set(ConnectionStatus.Connecting, true);
                while (!this._connected) {
                    log('Reconnecting...');
                    // sleep for 2 seconds
                    yield new Promise((resolve) => setTimeout(resolve, 1000));
                    yield this._connect();
                    if (this._connected) {
                        // Cancel any pending queries
                        this._takePendingQueries().forEach((f) => f.reject(new Error('WebSocket connection closed')));
                        return;
                    }
                }
            }
            finally {
                this._reconnecting = false;
            }
        });
    }
    _handleConnectionClosed() {
        return __awaiter(this, void 0, void 0, function* () {
            log('handling connection closed');
            // Clear the connected event to indicate disconnection
            this._connected = false;
            // Cancel pending requests and remove them from the pendingQueries dictionary
            // this._takePendingQueries().forEach((f) => f.reject(new Error('WebSocket connection closed')));
            if (this.connectionStatus.value === ConnectionStatus.Closed || this.connectionStatus.value == ConnectionStatus.Failed) {
                return;
            }
            // Log the disconnection
            log('WebSocket connection closed. Will attempt to reconnect.');
            yield this._reconnect();
        });
    }
    _takePendingQueries(batchId, statementId) {
        const ret = [];
        if (!batchId) {
            for (let x of this._pendingQueries.values()) {
                for (let y of x.values()) {
                    ret.push(y);
                }
            }
            this._pendingQueries.clear();
            return ret;
        }
        if (statementId) {
            let batch = this._pendingQueries.get(batchId);
            if (!batch) {
                return ret;
            }
            const future = batch.get(statementId);
            if (future) {
                ret.push(future);
                batch.delete(statementId);
                if (batch.size === 0) {
                    this._pendingQueries.delete(batchId);
                }
            }
        }
        else {
            let batch = this._pendingQueries.get(batchId);
            if (!batch) {
                return ret;
            }
            for (let fut of batch.values()) {
                ret.push(fut);
            }
            this._pendingQueries.delete(batchId);
        }
        return ret;
    }
}
exports.DwebgClient = DwebgClient;
DwebgClient.LOGGING_ENABLED = false;
